
import { mapState } from 'vuex'
import ScrouselTabs from '~/components/producet-scence/scrousel-tabs.vue'
import CreateExamination from '~/components/producet-scence/create-examination.vue'
import MoreShow from '~/components/producet-scence/more-show.vue'
import CustomerCase from '~/components/producet-scence/customer-case.vue'
import { getHomePageConfig } from '~/api/home/index.js'
import { set as setCookie, del as deleteCookie } from '~/utils/cookie.js'

export default {
  name: 'SassesSurvey',
  components: {
    ScrouselTabs,
    CreateExamination,
    MoreShow,
    CustomerCase,
  },
  layout: 'scence-single',
  data() {
    return {
      ConfData: {},
      nexturl: '/create/scene/create-template/?scene=survey',
    }
  },
  fetchOnServer: false,
  async fetch() {
    await this.init()
  },
  head: {
    title: '问卷网-市场调研问卷-免费调查问卷制作平台',
    link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/survey/' }],
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: '问卷调查,调查问卷,市场调查,产品调查,学生调查,问卷网',
      },
      {
        hid: 'description',
        name: 'description',
        content:
          '问卷调查就用问卷网，满足各类调研场景：市场调查、产品调查、学生调查，提供20余万精品调查问卷模板，支持微信，微博，QQ等多种发布模式，自动生成专业的分析报表。',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no',
      },
    ],
  },
  computed: {
    ...mapState(['isMobile', 'loginStatus']),
    href() {
      const path = this.nexturl
      return this.loginStatus.loggedIn == 1 ? path : ''
    },
  },
  mounted() {
    this.setRegisterConfig()
    this.setloginedCookie()
  },
  methods: {
    init() {
      return getHomePageConfig().then(({ data }) => {
        this.ConfData = {
          userNum: data?.total_member_count / 10000,
          dataNum: data?.total_rspd_count / 100000000,
        }
      })
    },
    /**
     * 修改登入界面的配置
     */
    setRegisterConfig() {
      // 配置登入页面
      this.$store.commit('setLoginStatus', {
        nexturl: this.nexturl,
      })
    },
    handLogin() {
      if (!this.loggedIn) {
        if (!this.isMobile)
          return this.$store.commit('setLoginStatus', {
            show: true,
          })
        this.$href('/m/login/?quicklogin=1&emailorusername=&vvv=16728549930973728')
      }
    },
    // 埋点设置
    setloginedCookie() {
      const {
        $route: {
          query: { utm_source },
        },
      } = this
      if (utm_source) setCookie('utm_source', utm_source)
    },
  },
}
